import HttpClient from 'server/helpers/HttpClient';

const httpClient = HttpClient.getInstance();

/**
 * Initialize PayPal checkout dialog
 */
export const openPayPalSandBox = () => {
  window.paypal.checkout.reset();
  window.paypal.checkout.initXO();
};

/**
 * Get PayPal checkout token for legacy PayPal flow
 */
export const getPayPalCheckOut = async (props) => {
  const {
    domainId,
    token,
    balanceAmount,
    paymentDueStatus,
    invoiceAmount,
    transactionType,
    currency,
    companyLocale,
    offerId,
    payment: { amount, payPalProcessor },
    auth: {
      ticket,
      realmId,
      isUserSignedIn,
      isEntityPromoted,
      entityId,
      syncToken,
      authToken,
      isSalesCheckoutInvoice,
      recipientEmail,
    },
    config: { ssrtid },
  } = props;
  const payorEmail = recipientEmail;
  let queryParams = window.location.search.slice(1);
  let params = [];
  if (queryParams) {
    params = queryParams
      .split('&')
      .filter((query) => query.indexOf('isPayPal') === -1 || query.indexOf('ssrtid') === -1);
  }
  params.push(['isPayPal=true']);
  params.push([`ssrtid=${ssrtid}`]);
  params.push([`payorEmail=${payorEmail}`]);
  if (transactionType) {
    params.push([`transactionType=${transactionType}`]);
  }

  if (!window.location.origin) {
    window.location.origin =
      `${window.location.protocol}//${window.location.hostname}` +
      (window.location.port ? ':' + window.location.port : '');
  }

  const returnURL = `${window.location.origin}${window.location.pathname}?${params.join('&')}`;
  const paymentBody = {
    amount,
    cancelURL: window.location.href,
    currencyCode: currency,
    guest: !isUserSignedIn,
    invoiceAmount,
    offerId: offerId || 'noOfferCode',
    paymentDueStatus: paymentDueStatus,
    paypalProcessor: payPalProcessor,
    prevBalance: balanceAmount,
    returnURL: returnURL,
  };

  const headers = {
    Accept: 'application/json, text/javascript, */*; q=0.01',
    'Content-Type': 'application/json',
    sessionticket: ticket,
    'intuit-authlevel': '5',
    'Intuit-RealmId': realmId,
    'Intuit-DomainId': domainId,
    'Intuit-IntuitId': entityId,
    'Intuit-ACSToken': token,
    'aws-wallet': true,
    token: token,
    isClientStateSignedIn: isUserSignedIn,
    isEntityPromoted: isEntityPromoted,
  };

  if (syncToken) {
    headers['syncToken'] = syncToken;
  }

  if (isSalesCheckoutInvoice) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }
  const payPalCheckOut = await httpClient({
    url: '/icnportal-server/rest/payments/paypal/initPay',
    method: 'POST',
    headers,
    data: paymentBody,
    endpoint: '/icnportal-server/rest/payments/paypal/initPay',
    ssrtid,
    token,
    companyLocale,
  });
  return payPalCheckOut;
};

export const startPayPalFlow = (paypalToken) => {
  const paypalCheckoutUrl = `${window.paypal.checkout.urlPrefix}${paypalToken}&useraction=commit`;
  window.paypal.checkout.startFlow(paypalCheckoutUrl);
};

export const closePayPalFlow = () => {
  window.paypal.checkout.closeFlow();
};

export const createOrderOnPayPalCommerce = async (paymentsValue) => {
  const {
    auth: { entityId, realmId, ticket, isUserSignedIn, syncToken, authToken },
    config: { portal, ssrtid },
    domainId,
    token,
    companyLocale,
    invoiceId,
    currency,
    payment: { amount, ppCreateOrderKey },
  } = paymentsValue;
  try {
    const paypalEndPoint = `/${portal}/app/CommerceNetwork/view/rest/external-payment/createOrder`;
    /**
     * @type {import('axios').RawAxiosRequestHeaders}
     */
    const requestHeaders = {
      Accept: 'application/json, text/javascript, */*; q=0.01',
      'Intuit-DomainId': domainId,
      'Intuit-IntuitId': entityId,
      'Intuit-RealmId': realmId,
      'Intuit-ACSToken': token,
      sessionTicket: ticket,
      'user-signed-in': typeof isUserSignedIn === 'boolean' ? isUserSignedIn.toString() : 'false',
      syncToken: syncToken,
      'ssr-session-id': ssrtid,
      'x-forwarded-for': '127.0.0.1',
      invoiceId: invoiceId,
      'invoice-amount': amount,
      currencyCode: currency,
      'pp-create-order-key': ppCreateOrderKey,
      Authorization: `Bearer ${authToken}`,
    };

    const paypalOrderIdCapture = await httpClient({
      url: paypalEndPoint,
      method: 'GET',
      endpoint: paypalEndPoint,
      headers: requestHeaders,
    });
    if (paypalOrderIdCapture.data.merchantDetailsResp === '') {
      const error = new Error('No Order Id Returned from PayPal');
      error.invoiceInfo = {
        ssrtid,
        companyLocale,
        token,
        ppCreateOrderKey,
      };
      throw error;
    }
    return paypalOrderIdCapture.data.merchantDetailsResp;
  } catch (error) {
    error.invoiceInfo = {
      ssrtid,
      companyLocale,
      token,
      ppCreateOrderKey,
    };
    throw error;
  }
};
